import React from 'react'
import AloModal from '../../AloModal'
import { Modal } from 'react-bootstrap'
import HelpPopup from '../../helpPopup/HelpPopup'
import PropTypes from 'prop-types'
import Switch from 'react-bootstrap-switch'
import PhotoSelector from '../../photoSelector/PhotoSelector'
import CameraIcon from '../../../../assets/codicons/camera-icon'
import PhotoUploader from '../../photoSelector/PhotoUploader'
import AloButton from '../../AloButton'
import CappedTextArea from '../../cappedTextArea/CappedTextArea'

const DESCRIPTION_MAX_COUNT = 500

class EditPlaylistModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      removingImage: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.onToggle = this.onToggle.bind(this)
    this.deleteCoverPhoto = this.deleteCoverPhoto.bind(this)
  }

  componentDidMount () {
    this.initializeFields()
  }

  componentDidUpdate (prevProps) {
    const playlist = this.props.playlist

    const playlistHasChanged =
      !prevProps.playlist || prevProps.playlist.uuid !== playlist.uuid

    if (playlistHasChanged) {
      this.initializeFields()
    }
  }

  initializeFields () {
    const playlist = this.props.playlist

    this.setState({
      title: playlist.title,
      description: playlist.description || '',
      private: playlist.private
    })
  }

  handleChange (e) {
    const target = e.target
    const targetName = target.name
    const value = target.value
    this.setState({
      [targetName]: value
    })
  }

  onToggle () {
    const currPrivate = !this.state.private
    this.setState({ private: currPrivate })
  }

  displayPlaylistImage () {
    if (this.state.remoteCoverPhotoUrl) {
      return <img src={this.state.remoteCoverPhotoUrl} />
    } else if (this.props.playlist.coverPhoto) {
      return <img src={this.props.playlist.coverPhoto.url} />
    }
  }

  deleteCoverPhoto (remoteKey) {
    this.setState({ removingImage: true })
    this.props.playlist.updateBackend({ [remoteKey]: true }).then(() => {
      this.props.onPlaylistUpdate({ coverPhoto: null })
      this.setState({
        openPhotoUploader: false,
        removingImage: false,
        remoteCoverPhotoUrl: ''
      })
    })
  }

  renderImageUploader () {
    const playlist = this.props.playlist

    const imageUrl = this.state.remoteCoverPhotoUrl || playlist.coverPhoto.url

    if (imageUrl) {
      return (
        <div className='workout-photo'>
          <div className='workout-photo-border'>
            {this.displayPlaylistImage()}
            <div
              className='icon-photo-edit'
              onClick={() => {
                this.setState({ openPhotoUploader: true })
              }}
            >
              <CameraIcon />
            </div>
          </div>
          <PhotoUploader
            show={this.state.openPhotoUploader}
            currentImageUrl={imageUrl}
            onHide={() => {
              this.setState({ openPhotoUploader: false })
            }}
            onUploaded={remoteCoverPhotoUrl => {
              this.setState({ remoteCoverPhotoUrl })
            }}
            onDelete={this.deleteCoverPhoto}
            photoType='cover'
            removingImage={this.state.removingImage}
          />
        </div>
      )
    } else {
      let backgroundImage
      if (playlist.firstEntry) {
        backgroundImage = playlist.firstEntry.videoThumbnail
      }
      return (
        <div className='EditPlaylistModal__playlistImage'>
          <img src={backgroundImage} />
          <div className='EditPlaylistModal__photoSelector'>
            <PhotoSelector
              transparent
              modifiying={!!playlist.coverPhoto}
              photoType='cover'
              onUploaded={remoteCoverPhotoUrl => {
                this.setState({ remoteCoverPhotoUrl })
              }}
            />
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <AloModal
        show={this.props.show}
        backdrop="static"
        onHide={this.props.onHide}
        className='EditPlaylistModal'
      >
        <Modal.Header>Edit playlist details</Modal.Header>
        <Modal.Body>
          <div className='new-playlist-form'>
            <h3>Name</h3>
            <input
              name='title'
              value={this.state.title}
              onChange={this.handleChange}
            />

            <h3>Description</h3>
            <CappedTextArea
              limit={DESCRIPTION_MAX_COUNT}
              name='description'
              value={this.state.description}
              onChange={this.handleChange}
              placeholder='How would you describe this playlist to your friend? (Max 500 characters)'
            />

            <div className='EditPlaylistModal__private'>
              <h3>
                Private Playlist{' '}
                <HelpPopup
                  trigger={<a className='hovertip'>?</a>}
                  width={520}
                  topOffset={-20}
                >
                  This will prevent other members from discovering and using
                  your playlist
                </HelpPopup>
              </h3>
              <Switch
                onChange={this.onToggle}
                on={<h2>On</h2>}
                off={<h2>Off</h2>}
                size='xs'
                offstyle='danger'
                value={this.state.private}
              />
            </div>

            <h3>Update Image</h3>
            <div className='EditPlaylistModal__image'>
              {this.renderImageUploader()}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button className='grey' onClick={this.props.onHide}>
            Cancel
          </button>
          <AloButton
            processing={this.state.submitting}
            onClick={() => {
              this.setState({ submitting: true })
              this.props.onPlaylistUpdate(this.state, () => {
                this.setState({ submitting: false })
                this.props.onHide()
              })
            }}
          >
            Done
          </AloButton>
        </Modal.Footer>
      </AloModal>
    )
  }
}

EditPlaylistModal.propTypes = {
  onHide: PropTypes.func,
  playlist: PropTypes.object,
  show: PropTypes.bool,
  onPlaylistUpdate: PropTypes.func
}

export default EditPlaylistModal
